export default [
    {
      path: '/tracking-login',
      name: 'tracking-login',
      component: () => import('@/views/tracking-taobao/login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectTrack: true,
      },
    },
    {
        path: '/search-tracking',
        name: 'search-tracking',
        component: () => import('@/views/tracking-taobao/tracking.vue'),
        meta: {
          layout: 'full',
          resource: 'TaobaoTracking',
        },
      },
  ]